import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  imgAlt: {
    id: 'pd.loyalty.modal.img.alt',
    defaultMessage: 'zákaznická sleva',
  },
});
